import * as React from 'react';

import { CheckCircleIcon } from '@heroicons/react/24/outline';

interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  onCheckedChange?: (checked: boolean) => void;
  id?: string;
  disabled?: boolean;
  className?: string;
  label?: React.ReactNode;
  children?: React.ReactNode;
}

export function Checkbox({
  checked = false,
  onChange,
  onCheckedChange,
  id,
  disabled,
  className = '',
  label,
  children,
}: CheckboxProps) {
  const handleToggle = () => {
    if (disabled) return;
    const next = !checked;
    onChange?.(next);
    onCheckedChange?.(next);
  };

  const box = (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      id={id}
      disabled={disabled}
      onClick={handleToggle}
      className={`h-4 w-4 flex-shrink-0 rounded border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/40 ${
        checked
          ? 'bg-primary border-primary'
          : 'bg-background border-input hover:border-orange-400'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
    >
      {checked && (
        <CheckCircleIcon className="h-3 w-3 text-white m-auto" />
      )}
    </button>
  );

  const content = label ?? children;
  if (!content) return box;

  return (
    <div
      className={`flex items-start gap-2.5 ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={handleToggle}
    >
      {box}
      <span className="text-xs text-muted-foreground leading-relaxed select-none">{content}</span>
    </div>
  );
}
